import { toNew } from './toNew';
import { splitSearchKeywordTerms } from './searchKeywordTerms';

// 正規表現の特殊文字をエスケープする
const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// 開始位置の順 (同じなら長い方が先) に並べ、重なる範囲を 1 つにまとめる (隣り合うだけの範囲はまとめない)
export const mergeOverlappingRanges = (ranges) => {
  const merged = [];
  [...ranges]
    .sort((a, b) => a[0] - b[0] || b[1] - a[1])
    .forEach(([start, end]) => {
      const last = merged[merged.length - 1];
      if (last && start < last[1]) {
        last[1] = Math.max(last[1], end);
      } else {
        merged.push([start, end]);
      }
    });
  return merged;
};

// 本文を「一致 / 非一致」の区間に分ける。
// 検索語は区切りの文字 (半角スペース・全角スペース・タブ) で語に分け、語ごとに一致範囲を集めて
// 重なる範囲を 1 つにまとめる (どれかの語に一致した範囲に色を付ける)。
// 旧字体と新字体を同じ字として照合するため、toNew を掛けた本文と検索語で位置を求め、
// 切り出しは元の本文から行う (toNew は 1 字 → 1 字・BMP 内なので位置は変わらない)。
export const buildHighlightSegments = (rawText, rawKeyword) => {
  const text = String(rawText ?? '').normalize('NFC');
  const terms = splitSearchKeywordTerms(rawKeyword);

  if (terms.length === 0) {
    return [{ text, matched: false }];
  }

  const converted = toNew(text);
  const ranges = [];
  terms.forEach((term) => {
    // 保存時に日本語隣接の空白・改行を除去しているため、画面の文章と検索語で
    // 空白の有無が食い違いうる。語から空白を除いたうえで 1 文字ずつ
    // エスケープし、間に \s* を挟んだ正規表現にすることで空白の有無を無視して
    // 一致させる（サロゲートペアが壊れないよう Array.from で分解する）。
    const keywordChars = Array.from(toNew(term.normalize('NFC'))).filter((ch) => !/\s/.test(ch));
    if (keywordChars.length === 0) {
      return;
    }

    // 大文字小文字を区別せず照合する（DB 側の utf8mb4_unicode_ci に合わせる）
    const pattern = new RegExp(keywordChars.map(escapeRegExp).join('\\s*'), 'gi');
    for (const m of converted.matchAll(pattern)) {
      if (m[0].length === 0) {
        continue;
      }
      ranges.push([m.index, m.index + m[0].length]);
    }
  });

  const merged = mergeOverlappingRanges(ranges);

  const segments = [];
  let cursor = 0;
  merged.forEach(([start, end]) => {
    if (start > cursor) {
      segments.push({ text: text.slice(cursor, start), matched: false });
    }
    segments.push({ text: text.slice(start, end), matched: true });
    cursor = end;
  });
  if (cursor < text.length) {
    segments.push({ text: text.slice(cursor), matched: false });
  }
  return segments;
};
